<template>
  <vx-input-group class="mb-base">
    <template slot="prepend">
      <div
        class="prepend-text bg-primary cursor-pointer"
        v-if="idx !== 0"
        @click="toggleAnd"
      >
        <span>{{ this.and | andor }}</span>
      </div>
      <div class="prepend-text bg-primary cursor-pointer" @click="toggleMustBe">
        <span>{{ this.mustBe | ififnot }}</span>
      </div>
    </template>

    <vs-select v-model="type" class="w-full">
      <vs-select-item
        :key="index"
        :value="item.type"
        :text="item.description"
        v-for="(item, index) in conditionTypes"
      />
    </vs-select>

    <template slot="append">
      <component
        v-if="type"
        v-bind:is="type"
        :condition="condition"
        :automationId="automationId"
        ref="customCondition"
      />
      <div class="my-auto">
        <feather-icon
          color="primary"
          icon="XIcon"
          @click="deleteCondition"
          svgClasses="h-5 w-5"
          class="cursor-pointer ml-2 mt-1"
        />
      </div>
    </template>
  </vx-input-group>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";
import HasReadMailCondition from "./HasReadMailCondition.vue";
import HasClickedMailCondition from "./HasClickedMailCondition.vue";
import HasLabelCondition from "./HasLabelCondition.vue";
import HasConsentCondition from "./HasConsentCondition.vue";
import IsDynamicFormCondition from "./IsDynamicFormCondition.vue";

export default {
  components: {
    HasReadMailCondition,
    HasLabelCondition,
    HasClickedMailCondition,
    HasConsentCondition,
    IsDynamicFormCondition,
  },
  props: ["condition", "idx", "automationId"],
  data() {
    return {
      type: null,
      and: true,
      mustBe: true,
      booleanTypes: [
        { name: "If", value: true },
        { name: "If not", value: false },
      ],
    };
  },
  methods: {
    deleteCondition() {
      this.$emit("deleteCondition", this.idx);
    },
    toggleAnd() {
      this.and = !this.and;
    },
    toggleMustBe() {
      this.mustBe = !this.mustBe;
    },
    render() {
      if (!this.type) return null;
      return {
        _type: this.type,
        and: this.and,
        mustBe: this.mustBe,
        ...this.$refs.customCondition.render(),
      };
    },
  },
  computed: {
    ...mapGetters({
      conditionTypes: "automations/conditionTypes",
    }),
  },
  async mounted() {
    if (this.condition) {
      this.mustBe = this.condition.mustBe;
      this.and = this.condition.and;
      this.type = this.condition._type;
    }
  },
};
</script>

<style lang="scss">
</style>